/**
 * @file 任务相关枚举定义
 * @description 所有任务状态和阶段的枚举定义
 */

/**
 * 任务状态枚举
 * 注意：任务状态和任务阶段是两个独立的维度
 * - 状态（State）：任务当前的执行状态
 * - 阶段（Stage）：任务当前所处的业务阶段
 * 每个阶段都可能有这些状态
 */
export enum TaskState {
    /** 草稿状态 */
    DRAFT = 'DRAFT',
    /** 已创建 */
    CREATED = 'CREATED',
    /** 初始化中（可行性判断） */
    INITIALING = 'INITIALING',
    /** 运行中 */
    RUNNING = 'RUNNING',
    /** 已暂停 */
    PAUSED = 'PAUSED',
    /** 已完成 */
    COMPLETED = 'COMPLETED',
    /** 失败 */
    FAILED = 'FAILED',
    /** 已取消 */
    CANCELLED = 'CANCELLED',
    /** 已终止 */
    TERMINATED = 'TERMINATED',
}

/**
 * 任务阶段枚举
 */
export enum TaskStage {
    /** 冷启动 */
    COLDSTART = 'COLDSTART',
    /** 演化阶段 */
    EVOLVE = 'EVOLVE',
    /** 演化续跑 */
    SELECT = 'SELECT',
    // 报告阶段还是在evolve里， 当演化阶段完成，page 为 REPORT生成报告
    //  stage 无 REPORT阶段
    // /** 报告 */
    REPORT = 'REPORT'
}
